import React from "react";
import ShopDTO from "@/dto/shop/ShopDTO";
import { useGlobalStore } from "@/store/hooks";
import { observer } from "mobx-react-lite";
import moment from "moment";

interface SubscriptionEndTimeProps {
    shop: ShopDTO;
}

const SubscriptionEndTime: React.FC<SubscriptionEndTimeProps> = function (props) {
    const { shop } = props;

    const globalStore = useGlobalStore();

    const ownerShop = globalStore.shopMapping.get(shop.ownerShopId);

    const shopSetting = globalStore.shopSettingMapping.get(shop.id);

    return (
        <div className="inline-block subscription-end-time text-muted text-small" style={{ verticalAlign: "middle" }}>
            {shopSetting ? (
                <span>
                    当前店铺到期时间：
                    {shopSetting.subscriptionEndTime
                        ? moment(shopSetting.subscriptionEndTime).format("YYYY-MM-DD")
                        : "无"}
                </span>
            ) : null}
            <span className="ml10">所属平台店铺：{ownerShop?.name || "无"}</span>
        </div>
    );
};

export default observer(SubscriptionEndTime);
